import { useTranslation } from "react-i18next";
import { Paper } from "@mui/material";

function PageSection({ title, children, translationKey }) {
  const { t } = useTranslation();

  return (
    <Paper
      className='p-4 my-4'
      elevation={0}>
      <div className='flex'>
        <img
          alt={t("altText:verticalDivider")}
          src='./../assets/icons/divider-vertical.svg'
          className='w-2 h-7'
        />
        <h2 className='text-lg ml-2 mb-3 font-semibold'>
          {translationKey ? t(translationKey) : title}
        </h2>
      </div>
      {children}
    </Paper>
  );
}

export default PageSection;
